// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2cec519e","247":"2aac0cdb","284":"b3d48688","627":"3ec43d27","768":"7a1bdbe9","828":"09fa7158","834":"f48527df","867":"c3385e95","923":"428fe486","938":"33c803e1"}[chunkId] + ".chunk.js";
};